require('./polyfill')(window.crypto);
